import { Card } from '@faceup/ui'
import { Layout } from '@faceup/ui-base'
import type { ReactNode } from 'react'
import PublicHeader from '../Components/PublicHeader'
import Footer from './Login/Footer'

const { Content } = Layout

type PageTemplateUnloggedProps = {
  children?: ReactNode
  contentUnderCard?: ReactNode
  isFooterShown?: boolean
}

const PageTemplateUnlogged = ({
  children,
  contentUnderCard,
  isFooterShown = false,
}: PageTemplateUnloggedProps) => (
  <Layout className='min-h-full'>
    <PublicHeader />
    <Content className='mb-8 flex shrink-0 flex-col flex-nowrap items-center justify-center'>
      <Card className='w-full max-w-[35rem]'>
        <div className='nowrap flex flex-col items-center px-5 py-14'>{children}</div>
      </Card>
      {contentUnderCard}
    </Content>
    {isFooterShown && <Footer />}
  </Layout>
)

export default PageTemplateUnlogged
